export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">关于51吃瓜网</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">一站式娱乐资讯导航平台</p>

        <div className="bg-background-50 rounded-2xl p-6 md:p-10">
          <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-4">
            51吃瓜网在线观看成立于2022年，是国内领先的一站式娱乐八卦资讯聚合与导航平台。我们致力于为广大吃瓜群众提供全网最新、最全、最及时的51吃瓜网官方入口和网址导航服务。
          </p>
          <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-4">
            平台每日追踪微博热搜、抖音热点、小红书爆款以及各大娱乐媒体报道，通过智能聚合与人工精选相结合的方式，
            将全网热门的明星动态、综艺爆料、影视资讯、话题事件整合呈现，确保每一位用户都能第一时间获取最新鲜的吃瓜内容。
          </p>
          <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-6">
            我们的入口团队7×24小时在线维护，持续更新51吃瓜网站入口与官网地址，当主站入口发生变化时，
            第一时间同步最新网址，保证用户始终通过正版安全渠道访问。站内还提供手机端便捷入口、热门专题合集、
            以及丰富的互动社区功能，让你随时随地畅快吃瓜。
          </p>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
            {[
              { num: '300万+', label: '月活用户' },
              { num: '100+', label: '内容源头' },
              { num: '5000+', label: '日均资讯' },
              { num: '99.9%', label: '入口可用率' },
            ].map((stat) => (
              <div key={stat.label} className="text-center p-4 rounded-xl bg-background-100">
                <div className="font-heading text-2xl md:text-3xl text-primary-500 mb-1">{stat.num}</div>
                <div className="text-xs md:text-sm text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}